/**
 * (P) 2019-2024 Lars Ermert
 * v2.1 - 24.09.03:
 *    - *changed* content height calculation
 *    - *fixed* 'only one open' did not work
 * v2.0 - 23.01.07:
 *    - *changed* switched to vanilla js
 */
class LeAccordion {

  constructor( options ) {

    this.options = {
      wrapper_class: 'le-accordion',
      entry_class: 'le-acc-entry',
      header_class: 'le-acc-header',
      content_class: 'le-acc-content',
      data_max_height_tag: 'le-acc-max-height',
      data_min_height_tag: 'le-acc-min-height',
      only_one_open: true,
      debug: false
    };

    if (options !== undefined) {
      Object.assign(this.options, options);
    }

    this._init();

    addEventListener("resize",  () => {
      this._doCalcs();
    });

    // just in case
    setTimeout( () => {
      this._doCalcs();
    }, 150);

    this._doCalcs();

  }

  _doCalcs() {
    this._calculateHeights();
    this._setMaxHeight();
  }

  _makeEntryContentVisible() {
    document.querySelectorAll('.'+this.options.wrapper_class+' .'+this.options.content_class).forEach((content, index) => {
      content.classList.add('-initialized');
    });
  }

  _init() {
    if (this.options.debug) console.log('Accordion: _init()');

    this._makeEntryContentVisible();

    // click event
    if (this.options.debug) console.log('Accordion: _init()', '.'+this.options.wrapper_class+' .'+this.options.header_class, document.querySelector('.'+this.options.wrapper_class+' .'+this.options.header_class));

    document.querySelectorAll('.'+this.options.wrapper_class+' .'+this.options.header_class).forEach( (ele, index) => {
      ele.addEventListener('click', (event) => {
        if (this.options.debug) console.log('Accordion: _init() > click', event);

        let target_ele = event.target.closest( '.' + this.options.header_class );
        let parent_ele = target_ele.parentElement;
        let izOpen = parent_ele.classList.contains('-open');

        // close all open entries if so wished
        if (this.options.only_one_open) {
          const opened_entries = document.querySelectorAll('.' + this.options.entry_class + '.-open');

          if (this.options.debug) console.log('Accordion: _init() > only one shall be open', opened_entries);

          if (opened_entries) {
            opened_entries.forEach( (ele, ind) => {
              ele.classList.remove('-open');
            });
          }

          if (parent_ele) {
            const header_ele = parent_ele.parentElement.querySelector('.m3acc-header');
            if (header_ele) {
              header_ele.classList.remove('_primary-bkgr');
            }
          }

        }

        // add to current if it was closed before
        if (!izOpen) {
          parent_ele.classList.add('-open');
          target_ele.classList.add('_primary-bkgr');
        } else {
          parent_ele.classList.remove('-open');
          target_ele.classList.remove('_primary-bkgr');
        }

        // apply the changes
        this._setMaxHeight();
      });
    });

  }


  /**
   * Calculates the max- and min-height for each entry based on the height of the title and content
   * @private
   */
  _calculateHeights() {

    if (this.options.debug) console.log('LeAccordion: _calculateHeights()');

    document.querySelectorAll('.'+this.options.wrapper_class+' .'+this.options.content_class).forEach((content, index) => {
      let parent_ele = content.parentElement;
      let title_ele = parent_ele.querySelector('.'+this.options.header_class);

      if (this.options.debug) console.log('LeAccordion: _calculateHeights() > ', content, content.offsetHeight, title_ele.offsetHeight);

      if (parent_ele && title_ele) {

        if (this.options.debug) console.log('LeAccordion: _calculateHeights() > ', title_ele.offsetHeight, content.offsetHeight + title_ele.offsetHeight);

        parent_ele.setAttribute('data-' + this.options.data_min_height_tag, title_ele.offsetHeight);
        parent_ele.setAttribute('data-' + this.options.data_max_height_tag, content.offsetHeight + title_ele.offsetHeight);

      } else {
        console.info('LeAccordion: _calculateHeights() > title and parent not found', title_ele, parent_ele);
      }

    })
  }


  /**
   * Calculates the max-height for each entry based on the data-m3acc-max-height value
   * @private
   */
  _setMaxHeight() {
    if (this.options.debug) console.log('LeAccordion: _setMaxHeight()');
    document.querySelectorAll('.'+this.options.entry_class).forEach((entry, index ) => {
      if (entry.classList.contains('-open')) {
        entry.style.maxHeight = entry.getAttribute('data-'+this.options.data_max_height_tag) + 'px';
      } else {
        entry.style.maxHeight = entry.getAttribute('data-'+this.options.data_min_height_tag) + 'px';
      }
    });
  }

}

export default LeAccordion